import { Injectable } from "@nestjs/common";
import { Repository } from "typeorm";
import { InjectRepository } from "@nestjs/typeorm";
import { GAPOrdersEntity } from "../entities/gap-orders.entity";
import { GapPdfInfoEntity } from "../entities/gap-pdf.entity";
import { ExternalReq } from "packages/libs/shared-models/src/common/pvh/externalreq";



@Injectable()
export class GapPdfRepository extends Repository<GapPdfInfoEntity> {

    constructor(@InjectRepository(GapPdfInfoEntity) private gapPdfRepo: Repository<GapPdfInfoEntity>
    ) {
        super(gapPdfRepo.target, gapPdfRepo.manager, gapPdfRepo.queryRunner);
    }


    async getPdfFileInfo(req: any): Promise<any[]> {
        console.log(req,'repoo')
        const query = this.createQueryBuilder('co')
          .select(`*,DATE_FORMAT(co.created_at, '%m/%d/%Y %H:%i') as upload_date`);
          if (req?.poNumber !== undefined) {
            const poNumbers = req.poNumber.split(',').map(poNumber => poNumber.trim());
            query.andWhere(`co.po_number IN (:...poNumbers)`, { poNumbers });
        }
        if (req.externalRefNo !== undefined) {
          query.andWhere(`co.buyer_name ='${req.externalRefNo}'`)
        }
    
    
        return await query.getRawMany();
      }
    

}
